



























































































































































































































































































































































































import Vue from "vue";
import * as SwalUtils from "../utils/SwalUtils.js";
import Swal from "sweetalert2";
import DossierLabels from "./DossierLabels.js";
import diff from "deep-diff";

import { RepositoryFactory } from "./../repositories/RepositoryFactory";
const DossierRepository = RepositoryFactory.get("dossier");

import { Personeelslid } from "../../types/dossier/data/Personeelslid";
import { Contact } from "../../types/dossier/data/Contact";
import { Gezin } from "../../types/dossier/data/Gezin";
import { Overige } from "../../types/dossier/data/Overige";

import DossierCard from "./DossierCard.vue";
import DossierCollapse from "./DossierCollapse.vue";
import EhrStepper from "./../interface/EhrStepper.vue";
import EhrNavigation from "./../interface/EhrNavigation.vue";
import ChangesList from "./ChangesList.vue";

import PersoneelslidForm from "./forms/PersoneelslidForm.vue";
import ContactForm from "./forms/ContactForm.vue";
import GezinForm from "./forms/GezinForm.vue";
import OverigeForm from "./forms/OverigeForm.vue";
import FileUpload from "./../inputs/FileUpload.vue";

import PersoneelslidView from "./views/PersoneelslidView.vue";
import ContactView from "./views/ContactView.vue";
import GezinView from "./views/GezinView.vue";
import OverigeView from "./views/OverigeView.vue";
import { BurgStaat } from "../../types/dossier/BurgStaat";
import { DossierCardName } from "../../types/dossier/DossierCardName";
import { Partner } from "../../types/dossier/Partner";
import { Change } from "../../types/dossier/Change";
import { Dossier } from "../../types/dossier/data/Dossier";
import { Step } from "../../types/interface/stepper/step";

export default Vue.extend({
  name: "mijn-dossier",
  components: {
    DossierCard,
    DossierCollapse,
    ChangesList,
    EhrStepper,
    EhrNavigation,
    PersoneelslidForm,
    ContactForm,
    GezinForm,
    OverigeForm,
    PersoneelslidView,
    ContactView,
    GezinView,
    OverigeView,
    FileUpload,
  },
  created: function () {
    this.getDossier();
  },
  data() {
    return {
      loaded: false,
      changesLoaded: false,
      isEditing: "none",
      moduleOptions: [] as string[],
      personeelslid: {} as Personeelslid,
      contact: {
        woonplaats: [{}],
        verblijfplaats: [{}],
        comnummer: [{}],
        email: [{}],
      } as Contact,
      gezin: {
        burgStaat: {} as BurgStaat,
        partner: {} as Partner,
        gezinsleden: [],
      } as Gezin,
      overige: {} as Overige,
      cache: {
        personeelslid: {} as Personeelslid,
        contact: {} as Contact,
        gezin: {} as Gezin,
        overige: {} as Overige,
      },
      remarks: {
        personeelslid: "",
        contact: "",
        gezin: "",
        overige: "",
      },
      wijzigingen: {
        personeelslid: [] as Change[],
        contact: [] as Change[],
        gezin: [] as Change[],
        overige: [] as Change[],
      },
      attachments: {
        personeelslid: [],
        contact: [],
        gezin: [],
        overige: [],
      },
      labels: DossierLabels,
      steps: [
        {
          icon: "id-card",
          name: "first",
          title: "Identificatie",
          subtitle: "Gegevens personeelslid",
          completed: false,
        },
        {
          icon: "phone",
          name: "second",
          title: "Contact",
          subtitle: "Contactgegevens",
          completed: false,
        },
        {
          icon: "user-friends",
          name: "third",
          title: "Gezinstoestand",
          subtitle: "Gezinsgegevens",
          completed: false,
        },
        {
          icon: "ellipsis-h",
          name: "fourth",
          title: "Overige",
          subtitle: "Overige gegevens",
          completed: false,
        },
      ] as Step[],
      activeStep: 1,
      stepsValidations: [true, true, true, true],
      isValidForm: true,
      isValidCard: {
        personeelslid: false,
        contact: false,
        gezin: false,
        overige: false,
      },
      disabledFieldsMap: {
        personeelslid: {
          naam: true,
          voornaam: true,
          roepnaam: true,
          geboortedatum: true,
          geboorteplaats: true,
          geboorteland: true,
          persMindervalide: true,
          geslacht: true,
          initialen: true,
          werknemerscode: true,
          stamnummer: true,
          contrStamnummer: true,
          inszNr: true,
          natio: true,
        },
        contact: {
          woonplaats: true,
          correspondentie: true,
          verblijfplaats: true,
          comnummer: true,
          email: true,
          werkEmail: true,
        },
        gezin: {
          burgStaat: {
            burgstaat: true,
            burgstaatDatum: true,
            huwelijksdatum: true,
          },
          partner: {
            naam: true,
            voornaam: true,
            nationaliteit: true,
            geboortedatum: true,
            geboorteplaats: true,
            beroep: true,
            werkgever: true,
            overlijdensdatum: true,
          },
          gezinsleden: {
            naam: true,
            voornaam: true,
            geboortedatum: true,
            overlijdensdatum: true,
            mindervalide: true,
            zorgbehoevend: true,
            tenLaste: true,
            nietMeerTenLaste: true,
            verwantschap: true,
          },
        },
        overige: {
          rekening: true,
          rijbewijs: true,
          nummerplaten: false,
          orcid: true,
        },
      },
      hiddenFieldsMap: {
        personeelslid: {
          naam: true,
          voornaam: true,
          roepnaam: true,
          geboortedatum: true,
          geboorteplaats: true,
          geboorteland: true,
          persMindervalide: true,
          geslacht: true,
          initialen: true,
          werknemerscode: true,
          stamnummer: true,
          contrStamnummer: true,
          inszNr: true,
          natio: true,
        },
        contact: {
          woonplaats: true,
          correspondentie: true,
          verblijfplaats: true,
          comnummer: true,
          email: true,
          werkEmail: true,
        },
        gezin: {
          burgStaat: {
            burgstaat: true,
            burgstaatDatum: true,
            huwelijksdatum: true,
          },
          partner: {
            naam: true,
            voornaam: true,
            nationaliteit: true,
            geboortedatum: true,
            geboorteplaats: true,
            beroep: true,
            werkgever: true,
            overlijdensdatum: true,
          },
          gezinsleden: {
            naam: true,
            voornaam: true,
            geboortedatum: true,
            overlijdensdatum: true,
            mindervalide: true,
            zorgbehoevend: true,
            tenLaste: true,
            nietMeerTenLaste: true,
            verwantschap: true,
          },
        },
        overige: {
          rekening: true,
          rijbewijs: true,
          nummerplaten: true,
          orcid: true,
        },
      },
      proofInfoFieldsMap: {
        personeelslid: {
          naam: "",
          voornaam: "",
          roepnaam: "",
          geboortedatum: "",
          geboorteplaats: "",
          geboorteland: "",
          persMindervalide: "",
          geslacht: "",
          initialen: "",
          werknemerscode: "",
          stamnummer: "",
          contrStamnummer: "",
          inszNr: "",
          natio: "",
        },
        contact: {
          woonplaats: "",
          correspondentie: "",
          verblijfplaats: "",
          comnummer: "",
          email: "",
          werkEmail: "",
        },
        gezin: {
          burgStaat: {
            burgstaat: "",
            burgstaatDatum: "",
            huwelijksdatum: "",
          },
          partner: {
            naam: "",
            voornaam: "",
            nationaliteit: "",
            geboortedatum: "",
            geboorteplaats: "",
            beroep: "",
            werkgever: "",
            overlijdensdatum: "",
          },
          gezinsleden: {
            naam: "",
            voornaam: "",
            geboortedatum: "",
            overlijdensdatum: "",
            mindervalide: "",
            zorgbehoevend: "",
            tenLaste: "",
            nietMeerTenLaste: "",
            verwantschap: "",
          },
        },
        overige: {
          rekening: "",
          rijbewijs: "",
          nummerplaten: [],
          orcid : "",
        },
      },
      warningFieldsMap: {
        personeelslid: {},
        contact: {},
        gezin: {},
        overige: {},
      },
      proofRequiredFieldsMap: {
        personeelslid: {
          naam: true,
          voornaam: false,
          roepnaam: false,
          geboortedatum: false,
          geboorteplaats: false,
          geboorteland: false,
          persMindervalide: false,
          geslacht: false,
          initialen: false,
          werknemerscode: false,
          stamnummer: false,
          contrStamnummer: false,
          inszNr: false,
          natio: false,
        },
        contact: {
          woonplaats: false,
          correspondentie: false,
          verblijfplaats: false,
          comnummer: false,
          email: false,
          werkEmail: false,
        },
        gezin: {
          burgStaat: {
            burgstaat: true,
            burgstaatDatum: true,
            huwelijksdatum: true,
          },
          partner: {
            naam: false,
            voornaam: false,
            nationaliteit: false,
            geboortedatum: false,
            geboorteplaats: false,
            beroep: false,
            werkgever: false,
            overlijdensdatum: false,
          },
          gezinsleden: {
            naam: false,
            voornaam: false,
            geboortedatum: false,
            overlijdensdatum: false,
            mindervalide: false,
            zorgbehoevend: false,
            tenLaste: false,
            nietMeerTenLaste: false,
            verwantschap: false,
          },
        },
        overige: {
          rekening: false,
          rijbewijs: false,
          nummerplaten: false,
          orcid: false,
        },
      },
      dossierAdditionRemarks: {
        personeelslid: "",
        contact: "",
        gezin: "",
        overige: "",
      },
      dossierAdditionFiles: {
        personeelslid: [],
        contact: [],
        gezin: [],
        overige: [],
      },
    };
  },
  computed: {
    dossier(): Dossier {
      return {
        personeelslid: this.personeelslid,
        contact: this.contact,
        gezin: this.gezin,
        overige: this.overige,
      };
    },
    isNewDossier(): boolean {
      return this.moduleOptions.includes("wizard-required");
    },
    personeelslidChanges(): Change[] {
      return this.wijzigingen.personeelslid.map((change) => change).slice(0, 3);
    },
    contactChanges(): Change[] {
      return this.wijzigingen.contact.map((change) => change).slice(0, 3);
    },
    gezinChanges(): Change[] {
      return this.wijzigingen.gezin.map((change) => change).slice(0, 3);
    },
    overigeChanges(): Change[] {
      return this.wijzigingen.overige.map((change) => change).slice(0, 3);
    },
    isDossierFormUpdated(): boolean {
      return diff(this.dossier, this.cache) != undefined;
    },
  },
  methods: {
    canSubmitAdditionsFor(cardName: DossierCardName): boolean {
      let cardNameString = cardName as string;
      return (
        this.dossierAdditionRemarks[cardNameString] != "" ||
        this.dossierAdditionFiles[cardNameString].length
      );
    },
    onUpdatePartner(value): void {
      this.gezin.partner = value;
    },
    resetCache(): void {
      this.cache = {
        personeelslid: {} as Personeelslid,
        contact: {} as Contact,
        gezin: {} as Gezin,
        overige: {} as Overige,
      };
    },
    editCard(cardName: DossierCardName): void {
      this.isEditing = cardName;
      this.resetCache();
      this.cacheAll();
    },
    cardHasChangesInProgress(cardName: DossierCardName): boolean {
      if (!this.changesLoaded) return true;
      let hasChanges = false;
      this.wijzigingen[cardName].forEach((ch) => {
        if (ch.requestStatus == 102 || ch.requestStatus == 206) {
          hasChanges = true;
        }
      });
      return hasChanges;
    },
    cacheAll(): void {
      this.cache.personeelslid = JSON.parse(JSON.stringify(this.personeelslid));
      this.cache.contact = JSON.parse(JSON.stringify(this.contact));
      this.cache.gezin = JSON.parse(JSON.stringify(this.gezin));
      this.cache.overige = JSON.parse(JSON.stringify(this.overige));
    },
    cancelEditing(): void {
      this.personeelslid = JSON.parse(JSON.stringify(this.cache.personeelslid));
      this.contact = JSON.parse(JSON.stringify(this.cache.contact));
      this.gezin = JSON.parse(JSON.stringify(this.cache.gezin));
      this.gezin.partner = JSON.parse(JSON.stringify(this.cache.gezin.partner));
      this.overige = JSON.parse(JSON.stringify(this.cache.overige));
      this.remarks = {
        personeelslid: "",
        contact: "",
        gezin: "",
        overige: "",
      };
      this.attachments = {
        personeelslid: [],
        contact: [],
        gezin: [],
        overige: [],
      };
      this.isEditing = "none";
    },
    async cancelChReqStep(wijziging: Change) {
      let message =
        "Bent u zeker dat u de aanvraag van " +
        wijziging.created +
        " wilt annuleren?";
      if (wijziging.steps.length == 1) {
        Swal.fire({
          title: message,
          text: "Deze bewerking kan niet ongedaan gemaakt worden.",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonText: "Nee",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ja",
        }).then((result) => {
          if (result.value) {
            this.postCancelDossierStep(
              wijziging.pRequest,
              wijziging.steps[0].pStep
            );
          }
        });
      }
    },
    async postCancelDossierStep(pRequest: number, pStep: number) {
      let res = await DossierRepository.deleteDossierStep(pRequest, pStep).then(
        (resp) => {
          SwalUtils.DisplaySuccessToast("Uw aanvraag werd geannuleerd.");
          this.getChangeRequests();
        }
      );
    },
    async submitChReqAddition(wijziging: Change, cardName: DossierCardName) {
      let remark = this.dossierAdditionRemarks[cardName];
      let attachments = this.dossierAdditionFiles[cardName];
      let pRequest = wijziging.pRequest;
      let res = await DossierRepository.submitDossierAddition(
        pRequest,
        remark,
        attachments,
        cardName
      ).then((resp) => {
        SwalUtils.DisplaySuccessToast("Uw aanvraag werd succesvol verstuurd.");
        this.getChangeRequests();
      });
    },
    submitDossierChanges(cardName?: DossierCardName): void {
      if (!cardName) {
        let before = this.cache;
        let after = this.dossier;
        let remark = this.remarks;
        let attachments = this.attachments;
        this.postDossierChanges(before, after, remark, attachments);
      } else {
        let before = this.cache[cardName];
        let after = this.dossier[cardName];
        let remark = this.remarks[cardName];
        let attachments = this.attachments[cardName];
        this.postDossierChanges(before, after, remark, attachments, cardName);
      }
    },
    async postDossierChanges(
      before,
      after,
      remark,
      attachments,
      cardName?: DossierCardName
    ) {
      if (cardName) {
        let res = await DossierRepository.postCardChanges(
          before,
          after,
          remark,
          attachments,
          cardName
        ).then(async (resp) => {
          this.displayChangesSubmittedDialog();
          this.cancelEditing();
          await this.getChangeRequests();
        }).catch(async (err) => {
          // server validation error: do nothing
        });
      } else {
        let res = await DossierRepository.postDossierChanges(
          before,
          after,
          remark,
          attachments
        ).then(async (resp) => {
          this.displayChangesSubmittedDialog();
          this.cancelEditing();
          this.moduleOptions.splice(this.moduleOptions.indexOf("wizard-required"), 1);
          await this.getChangeRequests();
        }).catch(async (err) => {
          // server validation error: do nothing
        });
      }

    },
    async getDossier() {
      let { data } = await DossierRepository.getDossier();
      if (data != null) {
        this.personeelslid = JSON.parse(
          JSON.stringify(data.dossier.personeelslid)
        );
        this.contact = JSON.parse(JSON.stringify(data.dossier.contact));
        this.gezin = JSON.parse(JSON.stringify(data.dossier.gezin));
        this.overige = JSON.parse(JSON.stringify(data.dossier.overige));
        this.moduleOptions = data.moduleOptions.map((option) => {
          return option.optionName;
        });
        this.cacheAll();
      }
      await this.getChangeRequests();
      await this.getDossierVelden();
    },
    async getChangeRequests() {
      let { data } = await DossierRepository.getChangeRequests();
      if (data) {
        this.wijzigingen = data;
      }
      this.loaded = true;
      this.changesLoaded = true;
    },
    async getDossierVelden() {
      let { data } = await DossierRepository.getDossierVelden();
      if (data) {
        for (const property in data) {
          data[property].forEach((dossierVeld) => {
            if (dossierVeld.parentId) {
              let currentParentField = this.getParentFieldById(
                data[property],
                dossierVeld.parentId
              );
              DossierLabels[property][currentParentField.naam][
                dossierVeld.naam
              ] = dossierVeld.label;
              if (property == "gezin") {
                this.proofInfoFieldsMap[property][currentParentField.naam][
                  dossierVeld.naam
                ] = dossierVeld.proofTooltip;

                this.proofRequiredFieldsMap[property][currentParentField.naam][
                  dossierVeld.naam
                ] = dossierVeld.needsProofOnChange;
                this.disabledFieldsMap[property][currentParentField.naam][
                  dossierVeld.naam
                ] = dossierVeld.disabled;
                this.hiddenFieldsMap[property][currentParentField.naam][
                  dossierVeld.naam
                ] = dossierVeld.isHidden;
              }
            }
            if (!dossierVeld.parentId) {
              if (property != "gezin") {
                this.proofRequiredFieldsMap[property][dossierVeld.naam] =
                  dossierVeld.needsProofOnChange;
                this.disabledFieldsMap[property][dossierVeld.naam] =
                  dossierVeld.disabled;
                this.hiddenFieldsMap[property][dossierVeld.naam] =
                  dossierVeld.isHidden;
                this.proofInfoFieldsMap[property][dossierVeld.naam] =
                  dossierVeld.proofTooltip;
                if (dossierVeld.warning) {
                  this.warningFieldsMap[property][dossierVeld.naam] =
                    dossierVeld.warning;
                }
              }
            }
            if (
              !dossierVeld.parentId &&
              !DossierLabels[property][dossierVeld.naam].objectName
            ) {
              DossierLabels[property][dossierVeld.naam] = dossierVeld.label;
            }
          });
        }
      }
    },
    getParentFieldById(fields, id) {
      return fields.find((field) => {
        return field.id == id;
      });
    },
    isParentField(fields, id) {
      return (
        fields.find((field) => {
          return field.parentId == id;
        }) != undefined
      );
    },
    displayChangesSubmittedDialog(): void {
      let title = "Aanvraag verstuurd";
      let text = "Uw wijzigingen werden succesvol aangevraagd.";
      let icon = "success";
      let button = "Ok!";
      SwalUtils.DisplaySuccessDialog(title, text, icon, button);
    },
    updateActiveStep(step): void {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.activeStep = step;
    },
    finishStepper(): void {
      this.submitDossierChanges();
    },
    async cancelStepper() {
      this.moduleOptions.splice(
        this.moduleOptions.indexOf("wizard-required"),
        1
      );
      let res = await DossierRepository.disableWizardRequired().then((resp) => {
        SwalUtils.DisplaySuccessToast("Deze stap werd overgeslagen.");
      });
      this.cancelEditing();
    },
    onValidationChange(isInvalid, cardName): void {
      if (this.isNewDossier) {
        this.stepsValidations[this.activeStep] = !isInvalid;
        this.isValidForm = !this.stepsValidations.includes(false);
      } else {
        this.isValidCard[cardName] = !isInvalid;
      }
    },
    onFilesChanged($event, cardName): void {
      this.attachments[cardName] = $event;
    },
    onAdditionFilesChanged($event, cardName): void {
      this.dossierAdditionFiles[cardName] = $event;
    },
    onRemarkChanged($event, cardName): void {
      this.remarks[cardName] = $event;
    },
  },
});
